import { RegisterWS } from "@app/core/user/data/network/register.ws";
import { NewUserData } from "@app/core/user/domain/new-user";
import { LoginResponse } from "@app/core/user/domain/login.reponse";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { CompleteProfileWS } from "@app/core/user/data/network/complete-profile.ws";
import { User } from "@app/core/user/domain/user";
import { GetUserProfileWS } from "@app/core/user/data/network/get-user-profile.ws";
import { EditUserProfileWS } from "@app/core/user/data/network/edit-user-profile.ws";
import { DeleteUserWS } from "@app/core/user/data/network/delete-user.ws";
import { UserRepo } from "@app/core/user/domain/repositories/user.repo";
import { UserProfilePictureRepo } from "@app/core/user/domain/repositories/user-profile-picture.repo";
import { UploadPhotoCapacitor } from "@app/core/user/data/capacitor/upload-photo.capacitor";
import { TakePhotoCameraCapacitor } from "@app/core/user/data/capacitor/take-photo-camera.capacitor";

/**
 * User repository that implements the user logic using the capacitor API.
 */
@Injectable()
export class UserCapacitorRepo implements UserProfilePictureRepo {
  constructor(
    private uploadPhotoCapacitor: UploadPhotoCapacitor,
    private takePhotoCameraCapacitor: TakePhotoCameraCapacitor
  ) {}

  uploadPhoto(): Observable<string> {
    return this.uploadPhotoCapacitor.execute();
  }
  takePhoto(): Observable<string> {
    return this.takePhotoCameraCapacitor.execute();
  }
}
